// TeaSource customizations (2026)
// See inline comments before document.querySelector(...) in renderFilters()
// and before onSubmitHandler() for details on the fixes.


/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      if (OverlayManager.isOpen(this.drawer)) {
        OverlayManager.close(this.drawer);
      } else {
        OverlayManager.open(this.drawer);
      }
    });
  }
}
customElements.define('facet-toggle', FacetsToggle);


/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const span = this.querySelector('span');
    const hideFilters = span.textContent;

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.drawer = document.getElementById('Sidebar-Container');
      this.drawer.classList.toggle('facets--sidebar-open');

      span.textContent = this.drawer.classList.contains('facets--sidebar-open') ? hideFilters : theme.strings.showFilters;
    });
  }
}
customElements.define('sidebar-toggle', SidebarToggle);

/**
 *  @class
 *  @function MoreFilters
 */
class MoreFilters extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', (e) => {
      let ul = this.closest('.thb-filter-content').querySelector('ul');

      if (ul.hasAttribute('filters-open')) {
        this.textContent = theme.strings.showMore;
        ul.removeAttribute('filters-open');
      } else {
        this.textContent = theme.strings.showLess;
        ul.setAttribute('filters-open', '');
      }
      e.preventDefault();
    });
  }
}
customElements.define('more-filters', MoreFilters);

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

static renderSectionFromFetch(url, event) {
  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;

      FacetFiltersForm.filterData = [
        ...FacetFiltersForm.filterData,
        {
          html,
          url
        }
      ];

      FacetFiltersForm.renderFilters(html, event);

      FacetFiltersForm.renderProductGridContainer(html);

      // TeaSource:
      // The new facet HTML now exists in the live DOM.
      // Build the nested Origin / Sub-origin structure now.
      teaSourceNestedFilters();
      teaSourceTeaStyleFilters();

      FacetFiltersForm.renderProductCount(html);
    });
}

static renderSectionFromCache(filterDataUrl, event) {
  const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

  FacetFiltersForm.renderFilters(html, event);

  FacetFiltersForm.renderProductGridContainer(html);

  // TeaSource:
  // The cached facet HTML is now in the live DOM.
  // Rebuild the nested Origin / Sub-origin structure.
  teaSourceNestedFilters();
  teaSourceTeaStyleFilters();

  FacetFiltersForm.renderProductCount(html);
}

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    document.getElementById('ProductGridContainer').querySelectorAll('.lazyload').forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
    document.getElementById('header')?.querySelector('.full-menu')?.setMenuHeight();
        // TeaSource:
    // If Show All was active before the facet redraw,
    // automatically load all pages for the new filtered results.

    if (window.teaSourceShowAllActive) {

      requestAnimationFrame(() => {

        teaSourceLoadAllProducts();

      });

    }
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll(
        '#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row'
      );

    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest('collapsible-row')
        : undefined;

      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };

    const facetsToRender = Array.from(facetDetailsElements)
      .filter(element => !matchesIndex(element));

    const countsToRender = Array.from(facetDetailsElements)
      .find(matchesIndex);


    facetsToRender.forEach((element) => {

      const sourceForm = element.closest('form').id;

      // TeaSource fix:
      // Scope the replacement to the originating form so
      // desktop and mobile facets stay synchronized.

      const target = document.querySelector(
        `#${sourceForm} collapsible-row[data-index="${element.dataset.index}"]`
      );

      if (target) {
        target.innerHTML = element.innerHTML;
      }

    });


    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);


    if (countsToRender) {

      const targetRow = event
        ? event.target.closest('collapsible-row')
        : null;

      if (targetRow) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          targetRow
        );
      }

    }
  }


  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {

      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;

    });

    FacetFiltersForm.toggleActiveFacets(false);
  }


  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {

      if (!html.querySelector(selector)) return;

      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;

      document.querySelector(selector).classList.remove('loading');

    });

  }


  static renderCounts(source, target) {

    const targetElement =
      target.querySelector('.facets__selected');

    const sourceElement =
      source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {

      targetElement.outerHTML =
        sourceElement.outerHTML;

    }

  }


  static updateURLHash(searchParams) {

    history.pushState(
      {
        searchParams
      },
      '',
      `${window.location.pathname}${
        searchParams && '?'.concat(searchParams)
      }`
    );

  }


    static getSections() {

    return [
      {
        section: document
          .getElementById('product-grid')
          .dataset.id,
      }
    ];

  }


// TeaSource fix (2026):
// Preserve existing URL parameters when submitting partial forms
// (e.g. desktop Sort By) so active filters are not lost.

  // TeaSource:
  // Remove Sub-origin filters whose parent Origin is no longer selected.
  //
  // Example:
  // China + Fujian selected
  // → uncheck China
  // → China is removed AND Fujian is removed.

  clearOrphanedSubOrigins(searchParams) {

    const selectedOrigins = new Set(
      searchParams.getAll('filter.p.m.custom.origin')
    );


    // Build a lookup of Origin GID -> country name
    // from the live facet HTML.

    const originGidToCountry = {};

    document
      .querySelectorAll(
        'input[name="filter.p.m.custom.origin"]'
      )
      .forEach((input) => {

        const label = document.querySelector(
          `label[for="${input.id}"]`
        );

        if (!label) return;

        const textElement =
          label.querySelector('.thb-filter-text');

        if (!textElement) return;

        let country =
          textElement.textContent.trim();

        if (country === 'Sri Lanka (Ceylon)') {
          country = 'Sri Lanka';
        }

        originGidToCountry[input.value] = country;

      });


    // Parent/child relationships.

    const subOriginMap = {

      China: [
        'Anhui',
        'Fujian',
        'Guangdong',
        'Guangxi',
        'Guizhou',
        'Hubei',
        'Hunan',
        'Jiangsu',
        'Sichuan',
        'Yunnan',
        'Zhejiang'
      ],

      India: [
        'Assam',
        'Darjeeling',
        'Nilgiri-South India'
      ],

      Japan: [
        'Aichi',
        'Kagoshima',
        'Kyoto',
        'Mie',
        'Miyazaki',
        'Saga',
        'Saitama',
        'Shizuoka'
      ],

      'Sri Lanka': [
        'Dimbula',
        'Kandy',
        'Nuwara Eliya',
        'Southern',
        'Uddapussellawa',
        'Uva'
      ],

      Taiwan: [
        'Nantou',
        'Taichung'
      ]

    };


    const subOriginToCountry = {};

    Object.entries(subOriginMap).forEach(
      ([country, subOrigins]) => {

        subOrigins.forEach((subOrigin) => {
          subOriginToCountry[subOrigin] = country;
        });

      }
    );


    // Look at every Sub-origin checkbox currently in the DOM.
    //
    // This works whether the items are still in Shopify's
    // original Sub-origin facet or have already been moved
    // underneath Origin.

    document
      .querySelectorAll(
        'input[name="filter.p.m.custom.sub_origin"]'
      )
      .forEach((input) => {

        const label = document.querySelector(
          `label[for="${input.id}"]`
        );

        if (!label) return;

        const textElement =
          label.querySelector('.thb-filter-text');

        if (!textElement) return;

        const subOrigin =
          textElement.textContent.trim();

        const country =
          subOriginToCountry[subOrigin];

        if (!country) return;


        // Find the Origin GID(s) representing this country.

        const countryOriginGids =
          Object.entries(originGidToCountry)
            .filter(([, mappedCountry]) =>
              mappedCountry === country
            )
            .map(([gid]) => gid);


        // If none of this country's Origin values are selected,
        // remove this Sub-origin from the new filter state.

        const countryIsSelected =
          countryOriginGids.some((gid) =>
            selectedOrigins.has(gid)
          );


        if (!countryIsSelected) {

          const remainingValues =
            searchParams
              .getAll(input.name)
              .filter(value => value !== input.value);

          searchParams.delete(input.name);

          remainingValues.forEach((value) => {
            searchParams.append(input.name, value);
          });

        }

      });

  }
  
  onSubmitHandler(event) {

    event.preventDefault();

    const form = event.target.closest('form');
    const formData = new FormData(form);

    // Start with the current URL so existing filters AND sort
    // are preserved.
    const searchParams =
      new URLSearchParams(window.location.search);

    // TeaSource:
    // Any new filter selection should always start on page 1.
    // Otherwise a filter selected from page 2+ can request a
    // page that does not exist in the filtered results.
    searchParams.delete('page');
    

    // Remove parameters owned by this form.
    // Use all form controls, not just FormData entries,
    // because unchecked checkboxes are omitted from FormData.

    const names = new Set(
      [...form.querySelectorAll("[name]")]
        .map(el => el.name)
    );


    for (const name of names) {
      searchParams.delete(name);
    }


    // Add back the submitted values.

    for (const [key, value] of formData.entries()) {

      if (value !== "") {
        searchParams.append(key, value);
      }

    }

      // TeaSource:
  // If an Origin was unchecked, remove all of its
  // Sub-origin selections before requesting the new results.

  this.clearOrphanedSubOrigins(searchParams);

    // Remove the default zero price value.

    if (
      searchParams.get('filter.v.price.gte') === "0.00"
    ) {
      searchParams.delete('filter.v.price.gte');
    }


    // Remove the maximum price if it represents
    // the full available price range.

    if (document.querySelector('.price_slider')) {

      if (
        searchParams.get('filter.v.price.lte') ===
        parseFloat(
          document.querySelector('.price_slider')
            .dataset.max
        ).toFixed(2)
      ) {

        searchParams.delete('filter.v.price.lte');

      }

    }


    FacetFiltersForm.renderPage(
      searchParams.toString(),
      event
    );

  }


  onActiveFilterClick(event) {

    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();


    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1
          );


    FacetFiltersForm.renderPage(url);

  }

}


// IMPORTANT:
// The FacetFiltersForm class MUST be completely closed
// before the TeaSource nested-filter function begins.

FacetFiltersForm.filterData = [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);

FacetFiltersForm.setListeners();


// ------------------------------------------------------------
// TeaSource: Nested Origin / Sub-origin filters
// ------------------------------------------------------------

function teaSourceNestedFilters() {

  const subOriginMap = {

    China: [
      'Anhui',
      'Fujian',
      'Guangdong',
      'Guangxi',
      'Guizhou',
      'Hubei',
      'Hunan',
      'Jiangsu',
      'Sichuan',
      'Yunnan',
      'Zhejiang'
    ],

    India: [
      'Assam',
      'Darjeeling',
      'Nilgiri-South India'
    ],

    Japan: [
      'Aichi',
      'Kagoshima',
      'Kyoto',
      'Mie',
      'Miyazaki',
      'Saga',
      'Saitama',
      'Shizuoka'
    ],

    'Sri Lanka': [
      'Dimbula',
      'Kandy',
      'Nuwara Eliya',
      'Southern',
      'Uddapussellawa',
      'Uva'
    ],

    Taiwan: [
      'Nantou',
      'Taichung'
    ]

  };


  // Convert:
  //
  // Anhui -> China
  // Fujian -> China
  // Assam -> India
  // etc.

  const subOriginToCountry = {};

  Object.entries(subOriginMap).forEach(
    ([country, subOrigins]) => {

      subOrigins.forEach((subOrigin) => {
        subOriginToCountry[subOrigin] = country;
      });

    }
  );


  // ----------------------------------------------------------
  // Process each facet form independently.
  // ----------------------------------------------------------

  document.querySelectorAll('facet-filters-form').forEach((form) => {

    const rows = form.querySelectorAll('collapsible-row');

    let originRow = null;
    let subOriginRow = null;


    // Find Origin and Sub-origin rows.

    rows.forEach((row) => {

      const title =
        row.querySelector('.thb-filter-title');

      if (!title) return;

      const label = title.textContent
        .trim()
        .toLowerCase()
        .replace(/[-–—]/g, '-');

      if (label === 'origin') {
        originRow = row;
      }

      if (label === 'sub-origin') {
        subOriginRow = row;
      }

    });


    if (!originRow || !subOriginRow) return;


    const originList =
      originRow.querySelector('ul.list-origin');

    const subOriginList =
      subOriginRow.querySelector('ul.list-sub-origin');


    if (!originList || !subOriginList) return;


    // ----------------------------------------------------------
    // STEP 1:
    // Collect every existing nested Sub-origin item.
    //
    // IMPORTANT:
    // Shopify can redraw the facet while our old nested lists
    // still exist. Therefore the fresh Shopify Sub-origin list
    // may already contain the original items.
    //
    // We rebuild one clean source list and deduplicate by the
    // actual Shopify input value.
    // ----------------------------------------------------------

    const allSubOriginItems = [];

    // Existing direct items from Shopify's original list.
    Array.from(
      subOriginList.querySelectorAll(':scope > li')
    ).forEach((item) => {
      allSubOriginItems.push(item);
    });


    // Existing items from any previously-created nested lists.
    form.querySelectorAll('.ts-sub-origin-list').forEach((nestedList) => {

      Array.from(nestedList.children).forEach((item) => {
        allSubOriginItems.push(item);
      });

    });


    // Remove every existing nested list.
    form.querySelectorAll('.ts-sub-origin-list').forEach((nestedList) => {
      nestedList.remove();
    });


    // ----------------------------------------------------------
    // STEP 2:
    // Rebuild a completely clean Sub-origin source list.
    //
    // Deduplicate using the Shopify filter value rather than
    // the displayed name.
    // ----------------------------------------------------------

    const seenSubOrigins = new Set();

    // Empty the original Shopify list.
    subOriginList.replaceChildren();


    allSubOriginItems.forEach((item) => {

      const input =
        item.querySelector('input[type="checkbox"]');

      const textElement =
        item.querySelector('.thb-filter-text');


      if (!input || !textElement) return;


      const key =
        input.value || textElement.textContent.trim();


      if (seenSubOrigins.has(key)) {
        return;
      }


      seenSubOrigins.add(key);

      // Make sure the item starts as a normal visible item.
      item.classList.remove(
        'thb-filter-content--hidden'
      );

      subOriginList.appendChild(item);

    });


    // ----------------------------------------------------------
    // STEP 3:
    // Build Origin lookup.
    // ----------------------------------------------------------

    const originItems = {};


    originList
      .querySelectorAll(':scope > li')
      .forEach((originItem) => {

        const textElement =
          originItem.querySelector('.thb-filter-text');

        if (!textElement) return;


        let country =
          textElement.textContent.trim();


        if (country === 'Sri Lanka (Ceylon)') {
          country = 'Sri Lanka';
        }


        originItems[country] = originItem;

      });


    // ----------------------------------------------------------
    // STEP 4:
    // Determine selected Origins from live checkboxes.
    // ----------------------------------------------------------

    const selectedOrigins = new Set();


    originList
      .querySelectorAll(
        ':scope > li > input[type="checkbox"]'
      )
      .forEach((input) => {

        if (!input.checked) {
          return;
        }


        const label =
          originList.querySelector(
            `label[for="${input.id}"]`
          );


        if (!label) return;


        const textElement =
          label.querySelector('.thb-filter-text');


        if (!textElement) return;


        let country =
          textElement.textContent.trim();


        if (country === 'Sri Lanka (Ceylon)') {
          country = 'Sri Lanka';
        }


        selectedOrigins.add(country);

      });


    // ----------------------------------------------------------
    // STEP 5:
    // Move each Sub-origin underneath its parent Origin.
    // ----------------------------------------------------------

    Array.from(
      subOriginList.querySelectorAll(':scope > li')
    ).forEach((subOriginItem) => {

      const textElement =
        subOriginItem.querySelector('.thb-filter-text');

      if (!textElement) return;


      const subOrigin =
        textElement.textContent.trim();


      const country =
        subOriginToCountry[subOrigin];


      if (!country) return;


      const originItem =
        originItems[country];


      if (!originItem) return;


      let nestedList =
        originItem.querySelector(
          ':scope > ul.ts-sub-origin-list'
        );


      if (!nestedList) {

        nestedList =
          document.createElement('ul');

        nestedList.className =
          'ts-sub-origin-list';

        originItem.appendChild(nestedList);

      }


      nestedList.appendChild(subOriginItem);

    });


    // ----------------------------------------------------------
    // STEP 6:
    // Show/hide each country's nested Sub-origin list.
    // ----------------------------------------------------------

    Object.entries(originItems)
      .forEach(([country, originItem]) => {

        const nestedList =
          originItem.querySelector(
            ':scope > ul.ts-sub-origin-list'
          );


        if (!nestedList) return;


        nestedList.style.display =
          selectedOrigins.has(country)
            ? 'block'
            : 'none';

      });


    // ----------------------------------------------------------
    // STEP 7:
    // Remove Shopify's standalone "Show more".
    // ----------------------------------------------------------

    const moreFilters =
      subOriginRow.querySelector('more-filters');


    if (moreFilters) {
      moreFilters.remove();
    }


    // ----------------------------------------------------------
    // STEP 8:
    // Hide the standalone Sub-origin collapsible row.
    // ----------------------------------------------------------

    subOriginRow.style.display = 'none';

  });

}

// ------------------------------------------------------------
// TeaSource: Nested Tea Type / Tea Style filters
// ------------------------------------------------------------

function teaSourceTeaStyleFilters() {

  const teaStyleMap = {

    'Oolong': [
      'Dan Cong',
      'Taiwanese',
      'Tieguanyin',
      'Wuyi (Rock)'
    ],

    'White': [
      'Bai Mu Dan',
      'Bai Hao Yin Zhen (Silver Needles)',
      'Shou Mei'
    ],

    'Puer & Dark': [
      'Hunan Dark',
      'Raw (Sheng) Puer',
      'Ripe (Shu) Puer'
    ]

  };


  // Convert:
  //
  // Dan Cong -> Oolong
  // Sencha -> Green
  // etc.

  const teaStyleToType = {};

  Object.entries(teaStyleMap).forEach(
    ([teaType, teaStyles]) => {

      teaStyles.forEach((teaStyle) => {
        teaStyleToType[teaStyle] = teaType;
      });

    }
  );


  // ----------------------------------------------------------
  // Process desktop and mobile facet forms independently.
  // ----------------------------------------------------------

  document.querySelectorAll('facet-filters-form').forEach((form) => {

    const rows = form.querySelectorAll('collapsible-row');

    let teaTypeRow = null;
    let teaStyleRow = null;


    // Find Tea Type and Tea Style rows.

    rows.forEach((row) => {

      const title =
        row.querySelector('.thb-filter-title');

      if (!title) return;

      const label = title.textContent
        .trim()
        .toLowerCase()
        .replace(/[-–—]/g, '-');

      if (label === 'tea type') {
        teaTypeRow = row;
      }

      if (label === 'tea style') {
        teaStyleRow = row;
      }

    });


    if (!teaTypeRow || !teaStyleRow) return;


    const teaTypeList =
      teaTypeRow.querySelector('ul');

    const teaStyleList =
      teaStyleRow.querySelector('ul');


    if (!teaTypeList || !teaStyleList) return;


    // ----------------------------------------------------------
    // STEP 1:
    // Collect all Tea Style items, including any previously
    // nested items.
    // ----------------------------------------------------------

    const allTeaStyleItems = [];


    Array.from(
      teaStyleList.querySelectorAll(':scope > li')
    ).forEach((item) => {
      allTeaStyleItems.push(item);
    });


    form.querySelectorAll('.ts-tea-style-list').forEach((nestedList) => {

      Array.from(nestedList.children).forEach((item) => {
        allTeaStyleItems.push(item);
      });

    });


    // Remove old nested lists before rebuilding.

    form.querySelectorAll('.ts-tea-style-list').forEach((nestedList) => {
      nestedList.remove();
    });


    // ----------------------------------------------------------
    // STEP 2:
    // Rebuild a clean Tea Style source list and deduplicate.
    // ----------------------------------------------------------

    const seenTeaStyles = new Set();

    teaStyleList.replaceChildren();


    allTeaStyleItems.forEach((item) => {

      const input =
        item.querySelector('input[type="checkbox"]');

      const textElement =
        item.querySelector('.thb-filter-text');


      if (!input || !textElement) return;


      const key =
        input.value || textElement.textContent.trim();


      if (seenTeaStyles.has(key)) {
        return;
      }


      seenTeaStyles.add(key);


      item.classList.remove(
        'thb-filter-content--hidden'
      );


      teaStyleList.appendChild(item);

    });


    // ----------------------------------------------------------
    // STEP 3:
    // Build Tea Type lookup.
    // ----------------------------------------------------------

    const teaTypeItems = {};


    teaTypeList
      .querySelectorAll(':scope > li')
      .forEach((teaTypeItem) => {

        const textElement =
          teaTypeItem.querySelector('.thb-filter-text');

        if (!textElement) return;


        const teaType =
          textElement.textContent.trim();


        teaTypeItems[teaType] =
          teaTypeItem;

      });


    // ----------------------------------------------------------
    // STEP 4:
    // Determine selected Tea Types.
    // ----------------------------------------------------------

    const selectedTeaTypes = new Set();


    teaTypeList
      .querySelectorAll(
        ':scope > li > input[type="checkbox"]'
      )
      .forEach((input) => {

        if (!input.checked) {
          return;
        }


        const label =
          teaTypeList.querySelector(
            `label[for="${input.id}"]`
          );


        if (!label) return;


        const textElement =
          label.querySelector('.thb-filter-text');


        if (!textElement) return;


        selectedTeaTypes.add(
          textElement.textContent.trim()
        );

      });


    // ----------------------------------------------------------
    // STEP 5:
    // Move only mapped Tea Styles beneath their Tea Type.
    //
    // Unmapped styles such as Blend, Dragon Pearls, Scented,
    // and Smoked are intentionally not moved anywhere.
    // ----------------------------------------------------------

    Array.from(
      teaStyleList.querySelectorAll(':scope > li')
    ).forEach((teaStyleItem) => {

      const textElement =
        teaStyleItem.querySelector('.thb-filter-text');

      if (!textElement) return;


      const teaStyle =
        textElement.textContent.trim();

      if (
        window.innerWidth >= 750 &&
        teaStyle === 'Bai Hao Yin Zhen (Silver Needles)'
      ) {
        textElement.innerHTML =
          'Bai Hao Yin Zhen<br>(Silver Needles)';
      }

      const teaType =
        teaStyleToType[teaStyle];


      // Not mapped = hidden.

      if (!teaType) {
        teaStyleItem.remove();
        return;
      }


      const teaTypeItem =
        teaTypeItems[teaType];


      if (!teaTypeItem) return;


      let nestedList =
        teaTypeItem.querySelector(
          ':scope > ul.ts-tea-style-list'
        );


      if (!nestedList) {

        nestedList =
          document.createElement('ul');

        nestedList.className =
          'ts-tea-style-list';

        teaTypeItem.appendChild(nestedList);

      }


      nestedList.appendChild(teaStyleItem);

    });


    // ----------------------------------------------------------
    // STEP 6:
    // Show Tea Styles only when their parent Tea Type is selected.
    // ----------------------------------------------------------

    Object.entries(teaTypeItems)
      .forEach(([teaType, teaTypeItem]) => {

        const nestedList =
          teaTypeItem.querySelector(
            ':scope > ul.ts-tea-style-list'
          );


        if (!nestedList) return;


        nestedList.style.display =
          selectedTeaTypes.has(teaType)
            ? 'block'
            : 'none';

      });

    // ----------------------------------------------------------
    // STEP 7:
    // If a parent Tea Type is unchecked, uncheck any selected
    // Tea Style sub-filters beneath it.
    // ----------------------------------------------------------

    Object.entries(teaTypeItems)
      .forEach(([teaType, teaTypeItem]) => {

        const parentInput =
          teaTypeItem.querySelector(
            ':scope > input[type="checkbox"]'
          );

        const nestedList =
          teaTypeItem.querySelector(
            ':scope > ul.ts-tea-style-list'
          );

        if (!parentInput || !nestedList) return;


        parentInput.addEventListener('change', () => {

          if (parentInput.checked) return;


          nestedList
            .querySelectorAll(
              'input[type="checkbox"]:checked'
            )
            .forEach((subFilter) => {

              subFilter.checked = false;

            });

        });

      });

    // ----------------------------------------------------------
    // STEP 8:
    // Remove Shopify's standalone "Show more".
    // ----------------------------------------------------------

    const moreFilters =
      teaStyleRow.querySelector('more-filters');

    if (moreFilters) {
      moreFilters.remove();
    }


    // ----------------------------------------------------------
    // STEP 9:
    // Hide the standalone Tea Style filter row.
    // ----------------------------------------------------------

    teaStyleRow.style.display = 'none';

  });

}

// Run nested filters on initial page load.

teaSourceNestedFilters();
teaSourceTeaStyleFilters();




/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

/**
 * TeaSource: Show All Products
 *
 * When Show All is activated, remember that state for the
 * current page session. If filters later redraw the product
 * grid, automatically load all remaining filtered pages.
 */

window.teaSourceShowAllActive = false;


async function teaSourceLoadAllProducts() {

  const productGrid =
    document.querySelector('#product-grid');

  if (!productGrid) return;


  let paginationWrapper =
    document.querySelector('.pagination--wrapper');


  // Build the base URL from the current page.
  // Keep all filters, search terms, sorting, etc.
  // Remove only the page parameter.

  const baseUrl =
    new URL(window.location.href);

  baseUrl.searchParams.delete('page');


  // Fetch a specific page while preserving all
  // current filters and other URL parameters.

  const fetchPage = async (page) => {

    const pageUrl =
      new URL(baseUrl.href);

    pageUrl.searchParams.set(
      'page',
      page
    );


    const response =
      await fetch(pageUrl.href);


    if (!response.ok) {
      throw new Error(
        `HTTP ${response.status}`
      );
    }


    const html =
      await response.text();


    const doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const grid =
      doc.querySelector('#product-grid');


    if (!grid) {
      throw new Error(
        'Product grid not found.'
      );
    }


    return {
      grid,
      hasNextPage: !!doc.querySelector(
        '.pagination .next a:not([disabled])'
      )
    };

  };


  // Add products from a fetched grid.

  const appendProducts =
    (sourceGrid) => {

      const loadingOverlay =
        productGrid.querySelector(
          ':scope > .loading-overlay'
        );


      Array.from(sourceGrid.children)
        .forEach((item) => {

          if (
            item.classList.contains(
              'loading-overlay'
            )
          ) {
            return;
          }


          const importedItem =
            document.importNode(
              item,
              true
            );


          if (loadingOverlay) {

            productGrid.insertBefore(
              importedItem,
              loadingOverlay
            );

          } else {

            productGrid.appendChild(
              importedItem
            );

          }

        });

    };


  try {

    // --------------------------------------------------------
    // Start over with Page 1.
    //
    // This guarantees the final order is:
    //
    // Page 1 → Page 2 → Page 3 → Page 4...
    //
    // regardless of which page the customer started on.
    // --------------------------------------------------------

    const firstPage =
      await fetchPage(1);


    // Replace the current products with Page 1.

    const currentItems =
      Array.from(productGrid.children);


    currentItems.forEach((item) => {

      if (
        !item.classList.contains(
          'loading-overlay'
        )
      ) {

        item.remove();

      }

    });


    appendProducts(
      firstPage.grid
    );


    // --------------------------------------------------------
    // Load every subsequent page.
    // --------------------------------------------------------

    let page = 2;
    let hasNextPage =
      firstPage.hasNextPage;


    while (hasNextPage) {

      const nextPage =
        await fetchPage(page);


      appendProducts(
        nextPage.grid
      );


      hasNextPage =
        nextPage.hasNextPage;


      page++;

    }


    // --------------------------------------------------------
    // All filtered products are now loaded.
    // --------------------------------------------------------

    paginationWrapper =
      document.querySelector(
        '.pagination--wrapper'
      );


    if (paginationWrapper) {
      paginationWrapper.remove();
    }


    // Make lazy-loaded product images available.

    document
      .querySelectorAll(
        '#product-grid .lazyload'
      )
      .forEach((image) => {

        if (
          typeof lazySizes !== 'undefined' &&
          lazySizes.loader
        ) {

          lazySizes.loader.unveil(image);

        }

      });


  } catch (error) {

    console.error(
      'TeaSource Show All error:',
      error
    );

  }

}


/**
 * Handle the Show All button.
 */

document.addEventListener('click', (event) => {

  const button =
    event.target.closest(
      '.show-all-products-button'
    );


  if (!button) return;


  event.preventDefault();


  if (
    button.dataset.loading === 'true'
  ) {
    return;
  }


  // Remember that Show All is active.
  window.teaSourceShowAllActive = true;


  button.dataset.loading = 'true';
  button.disabled = true;
  button.classList.add('loading');


  teaSourceLoadAllProducts()
    .catch((error) => {

      console.error(
        'TeaSource Show All error:',
        error
      );

      button.disabled = false;
      button.dataset.loading = 'false';
      button.classList.remove('loading');

    });

});